import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

const SiteDownComponent = () => {
  const [selectedLanguage, setSelectedLanguage] = useState('en-US');
  // const { contentfulData } = useSelector(
  //   (state: { contentful: any }) => state.contentful
  // );
  const contentfulData = useSelector(
    (state: { contentful?: any }) => state.contentful?.contentfulData || {}
  );
  const { entries, assets } = contentfulData || {};
  console.log('entries', assets, entries);
  useEffect(() => {
    const storedLanguage = localStorage.getItem('language') || 'en-US';
    setSelectedLanguage(storedLanguage);
  }, []);
  const handleLanguageChange = () => {
    let newLanguage = 'en-US';

    if (selectedLanguage == 'en-US') {
      newLanguage = 'fr';
    } else {
      newLanguage = 'en-US';
    }
    setSelectedLanguage(newLanguage);

    localStorage.setItem('language', newLanguage);
    console.log(`Language changed to: ${newLanguage}`);
    window.location.href = `/sign-in?locale=${newLanguage}`;
  };
  return (
    <div className="bg-[#1F1F1F] h-full p-5 md:p-0">
      <div
        className="hidden md:flex justify-end px-10 py-5 cursor-pointer hover:underline"
        onClick={() => handleLanguageChange()}
      >
        <h1
          className="text-lg text-white hover:underline"
          aria-label="Language selection"
        >
          {selectedLanguage == 'fr'
            ? entries?.rb_header?.englishTitle
            : entries?.rb_header?.frenchTitle}
        </h1>
      </div>

      <div className="flex justify-center items-center">
        <img
          src={assets?.rb_logo_white}
          alt={'Rogers Logo'}
          width={208}
          height={26}
        />
      </div>
      <div className="flex p-[40px] gap-[20%] md:flex-col flex-col xl:flex-row lg:flex-row">
        <div className="text-white w-[100%] md:w-[100%] xl:w-[50%] lg:w-[50%]">
          <h1 className="text-[24px] font-bold leading-[34px] tracking-[0.101px] font-sf text-center xl:text-left lg:text-left md:text-center">
            {entries?.rb_error?.siteDownErrors?.title}
          </h1>
          <p className="text-[15px] font-[300] leading-[22px] tracking-[-0.07px] font-sf mt-6 text-center xl:text-left lg:text-left md:text-center">
            {entries?.rb_error?.siteDownErrors?.desc}
          </p>
        </div>
        <div className="text-white w-[50%]">
          <div className="absolute md:bottom-[11%] xl:bottom-[20%]  lg:bottom-[20%]  bottom-[20%] right-[8%]">
            <img
              src={assets?.greyRogersLogoIcon}
              alt={'Rogers Logo'}
              width={326}
              height={326}

              //style={{ top: '25%', right: '8%', position: 'absolute' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SiteDownComponent;
